import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";

import { EstRetiroMatDir, BusquedaEstIndDir } from "../../funciones/EstudiantesFunction";

import EstudiantesRetiroTableAdmin from "./EstudiantesRetiroTableAdmin";

class RetiroMateriassAdmin extends Component {
    state = {
        strings: "",
        icon2: "",
        estudiantes: [],
        preload: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando Solicitudes de Retiro de Materias"
        },
        cantEst: <i className="fa fa-spinner fa-spin"></i>,
    }
    
    componentDidMount = () => {
        this.busquedaEstudiante()
    }

    busquedaEstudiante = () => {
        EstRetiroMatDir((resp) => {
            let preloadIcon = "";
            let preloadText = "";

            if (resp.length === 0) {
                preloadIcon = "fa fa-times";
                preloadText = "No tienes solicitudes de retiro de materias"
            }

            this.setState({
                estudiantes: resp,
                cantEst: resp.length,
                preload: {
                    icon: preloadIcon,
                    text: preloadText
                }
            })
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    busquedaEst = () => (e) => {

    }

    listRetiroMat = () => {
        let {estudiantes, preload} = this.state;

        if (estudiantes.length === 0) return (
            <tr>
                <td colSpan={3} align="center"><i className={preload.icon}></i> {preload.text}</td>
            </tr>
        )

        return (
            estudiantes.map(option => (
                <EstudiantesRetiroTableAdmin
                tipo = "Solicitud"
                key={option.id}
                data={option}
                update = {()=> {this.busquedaEstudiante()}}
                />
            ))
        )
    }
    
    render() {
        let {strings, icon2, cantEst} = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    Búsqueda de Estudiantes <i className={icon2}></i>
                    <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={strings} onChange={this.cambiaValor("strings")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                </div>
                <div className="custom-mt-10 text-danger">Estudiantes con solicitudes pendientes ({cantEst})</div>
                <div className="custom-alert-warning" style={{padding: 5}}>
                    <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: "40vh"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color-warning">
                                    <td width="60%" style={styles}><strong>Estudiantes</strong></td>
                                    <td width="30%" align="center" style={styles}><strong>Carrera</strong></td>
                                    <td width="10%" align="center" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {this.listRetiroMat()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
 
export default RetiroMateriassAdmin;


// WEBPACK FOOTER //
// ./src/views/Administracion/RetiroMateriasAdmin.jsx